<script>
  import { cart, myOrder } from "../stores.js";
  import { location, push } from "svelte-spa-router";
  import { isObjectEmpty } from "../utils.js";
  import { onDestroy, onMount } from "svelte";
  import BagIcon from "./icons/BagIcon.svelte";

  export let showAnimation = true;

  let itemsCount = 0;
  let lastCount = 0;
  let addAnimEl;

  $: {
    itemsCount = 0;
    if (!$cart || isObjectEmpty($cart.items)) itemsCount = 0;
    else {
      Object.values($cart.items).forEach((cartItem) => {
        itemsCount += cartItem.count;
      });
    }
  }

  let floatUpAnimm = [
    {
      opacity: 0,
      transform: "translateY(0px)",
    },

    {
      opacity: 1,
      transform: "translateY(-20px)",
    },
    {
      opacity: 1,
      transform: "translateY(-25px)",
    },
    {
      opacity: 0,
      transform: "translateY(-25px)",
    },
  ];

  $: {
    if (showAnimation) {
      if (addAnimEl && itemsCount > lastCount) {
        addAnimEl.animate(floatUpAnimm, { duration: 300 });
        lastCount = itemsCount;
      }
    }
  }

  function gotoCart() {
    if (!$location.startsWith("/cart/")) {
      push("/cart/");
    }
  }

  onMount(() => {
    lastCount = itemsCount;
  });

</script>

<div class="bag" on:click={gotoCart}>
  {#if $myOrder}
    {#if $myOrder.status == 'ready'}
      <div class="vIcon">
        <div />
        <div />
      </div>
    {:else}
      <div class="loading">
        <img src="images/loading.png" alt="הזמנה פעילה" />
      </div>
    {/if}
  {:else if itemsCount > 0}
    <div class="itemsCount">{itemsCount}</div>
  {/if}
  <BagIcon color="white" />
  <span bind:this={addAnimEl} class="addAnim">+1</span>
</div>

<style>
  .addAnim {
    position: absolute;
    z-index: 1000;
    right: -14px;
    font-family: "Rubik";
    font-weight: 900;
    color: white;
    opacity: 0;
  }

  .bag {
    position: relative;
    width: 100%;
    max-width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    box-sizing: border-box;
  }

  .itemsCount {
    position: absolute;
    z-index: 999;
    bottom: 12px;
    font-size: 1.2rem;
    font-weight: 500;
    background: #ffac56;
    width: 18px;
    height: 18px;
    text-align: center;
    border-radius: 30px;
    line-height: 20px;
    color: white;
  }

  .loading {
    position: absolute;
    border-radius: 100px;
    width: 20px;
    height: 20px;
    top: 18px;
    animation: 1s infinite linear rotate;
  }

  .loading > img {
    width: 100%;
    height: auto;
  }

  .vIcon {
    position: absolute;
    transform: rotate(225deg) translate(-9px, -12px);
  }

  .vIcon > div:nth-child(1) {
    position: absolute;
    width: 12px;
    height: 5px;
    background: var(--green1);
    border-radius: 50px;
  }

  .vIcon > div:nth-child(2) {
    position: absolute;
    width: 5px;
    height: 18px;
    background: var(--green1);
    border-radius: 50px;
  }

</style>
